(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after"] && !Shopify.designMode) return;
  try {
    
  document.querySelector('#before-after-input-range').addEventListener('input', (e) => {
    const container = document.querySelector('.before-after__container');
    container.style.setProperty('--after-image-width', `${e.target.value}%`);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.isScrolling = null;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky = ['always', 'reduce-logo-size'].includes(this.getAttribute('data-sticky-type'));
      this.predictiveSearch = this.querySelector('predictive-search');

      this.init();
    }

    init() {
      this.setHeaderHeight();
      this.setupEventListeners();
      this.createObserver();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
    }

    setupEventListeners() {
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);
      this.setHeaderHeightBound = this.setHeaderHeight.bind(this);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      window.matchMedia('(max-width: 99rem)').addEventListener('change', this.setHeaderHeightBound);
    }

    setHeaderHeight = () => {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    };

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      window.matchMedia('(max-width: 99rem)').removeEventListener('change', this.setHeaderHeightBound);

      if (this.isScrolling) {
        clearTimeout(this.isScrolling);
      }
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch?.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.handleScrollDown();
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.handleScrollUp();
      } else if (scrollTop <= this.headerBounds.top) {
        this.handleScrollToTop();
      }

      this.currentScrollTop = scrollTop;
    };

    handleScrollDown() {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventHide) {
        requestAnimationFrame(() => this.hide());
      }
    }

    handleScrollUp() {
      this.header.classList.add('scrolled-past-header');
      if (!this.preventReveal) {
        requestAnimationFrame(() => this.reveal());
      } else {
        clearTimeout(this.isScrolling);
        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);
        requestAnimationFrame(() => this.hide());
      }
    }

    handleScrollToTop() {
      this.header.classList.remove('scrolled-past-header');
      requestAnimationFrame(() => this.reset());
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures ??= this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal ??= this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  class HeaderSearch {
    constructor() {
      this.MOBILE_BREAKPOINT = 989;
      this.FOCUS_DELAY = 100;

      this.elements = {
        searchToggle: document.querySelector('.header__search-toggle'),
        searchDropdown: document.querySelector('.header__search-dropdown'),
        searchOverlay: document.querySelector('[data-header-search-overlay]'),
        backArrow: document.querySelector('.header__back-arrow'),
        mobileSearchInput: document.querySelector('.header__search-field .search-form__input'),
        headerSearch: document.querySelector('.header__search'),
        mobileTopbar: document.querySelector('.mobile-topbar'),
        menuContainer: document.querySelector('.header__inline-menu'),
        actionsContainer: document.querySelector('.header__actions'),
        logo: document.querySelector('.header__logo'),
        header: document.querySelector('.header'),
      };
      this.onMenuHover = this.onMenuHover.bind(this);
      this.resizeFrame = null;
      this.scrollLockActive = false;
      this.originalRootOverflow = '';
      this.originalBodyOverflow = '';

      this.init();
    }

    init() {
      this.setHeaderHeightVar();

      if (this.isMobileSearchOpen()) {
        this.closeMobileSearch({ focusToggle: false, resetInput: false });
      }

      if (this.elements.searchToggle && this.elements.searchDropdown) {
        this.setupSearchToggle();
        this.setupOutsideClick();
        this.setupMenuHoverClose();
      }

      if (this.elements.backArrow && this.elements.header) {
        this.setupBackButton();
      }

      this.setupResizeHandler();
      this.setupKeyboardHandler();
    }

    isMobile = () => window.innerWidth <= this.MOBILE_BREAKPOINT;

    isMobileSearchOpen = () => this.elements.header?.classList.contains('header--search-mode');

    setMobileTopbarVisibility = (isVisible) => {
      if (!this.elements.mobileTopbar) return;
      this.elements.mobileTopbar.style.display = isVisible ? '' : 'none';
    };

    lockScroll = () => {
      if (this.scrollLockActive) return;
      const root = document.documentElement;
      const body = document.body;
      if (!root || !body) return;
      this.originalRootOverflow = root.style.overflow;
      this.originalBodyOverflow = body.style.overflow;
      root.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
      this.scrollLockActive = true;
    };

    unlockScroll = () => {
      if (!this.scrollLockActive) return;
      const root = document.documentElement;
      const body = document.body;
      if (!root || !body) return;
      root.style.overflow = this.originalRootOverflow || '';
      body.style.overflow = this.originalBodyOverflow || '';
      this.scrollLockActive = false;
    };

    setHeaderHeightVar = () => {
      if (!this.elements.header) return;
      const headerHeight = this.elements.header.offsetHeight;
      if (!headerHeight) return;
      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
    };

    setupSearchToggle() {
      this.elements.searchToggle.addEventListener('click', () => {
        if (this.isMobile()) {
          this.handleMobileSearch();
        } else {
          this.handleDesktopSearch();
        }
      });
    }

    handleMobileSearch() {
      if (this.isMobileSearchOpen()) {
        this.closeMobileSearch({ focusToggle: true, resetInput: false });
        return;
      }

      this.openMobileSearch();
    }

    openMobileSearch() {
      this.setMobileTopbarVisibility(false);
      this.elements.header.classList.add('header--search-mode');
      this.setHeaderHeightVar();
      this.lockScroll();
      const shouldOpenDropdown = this.shouldOpenMobileDropdown();
      this.showOverlay();
      if (shouldOpenDropdown) {
        this.elements.searchDropdown?.classList.add('is-open');
      } else {
        this.elements.searchDropdown?.classList.remove('is-open');
      }
      if (this.elements.mobileSearchInput) {
        setTimeout(() => this.elements.mobileSearchInput.focus(), this.FOCUS_DELAY);
      }
    }

    closeMobileSearch = ({ focusToggle = false, resetInput = false } = {}) => {
      if (!this.isMobileSearchOpen()) return;

      this.elements.header.classList.remove('header--search-mode');
      this.setMobileTopbarVisibility(true);
      this.setHeaderHeightVar();
      this.closeSearchFlyout();
      this.unlockScroll();
      this.elements.searchDropdown?.classList.remove('is-open');
      this.hideOverlay(true);

      if (resetInput && this.elements.mobileSearchInput) {
        this.elements.mobileSearchInput.value = '';
        this.elements.mobileSearchInput.dispatchEvent(new Event('input', { bubbles: true }));
      }

      if (focusToggle && this.elements.searchToggle) {
        this.elements.searchToggle.focus();
      }
    };

    handleDesktopSearch() {
      if (this.isMobileSearchOpen()) {
        this.closeMobileSearch({ focusToggle: false, resetInput: false });
      }

      const isOpen = this.elements.searchDropdown.classList.toggle('is-open');
      if (isOpen) {
        this.setHeaderHeightVar();
        this.showOverlay();
        const desktopSearchInput = this.elements.searchDropdown.querySelector('.search-form__input');
        if (desktopSearchInput) {
          setTimeout(() => desktopSearchInput.focus(), this.FOCUS_DELAY);
        }
      } else {
        this.hideOverlay();
      }
    }

    setupOutsideClick() {
      document.addEventListener('click', (event) => {
        const { searchDropdown, searchToggle, headerSearch } = this.elements;
        const clickedInsideHeaderSearch = headerSearch?.contains(event.target);

        if (this.isMobile()) {
          if (!this.isMobileSearchOpen()) return;
          const overlay = this.elements.searchOverlay || document.querySelector('[data-header-search-overlay]');
          const clickedOverlay = overlay?.contains(event.target);
          const clickedBackArrow = this.elements.backArrow?.contains(event.target);
          if (!clickedOverlay && !clickedBackArrow) {
            return;
          }
          this.closeMobileSearch({
            focusToggle: Boolean(clickedBackArrow),
            resetInput: Boolean(clickedBackArrow),
          });
          return;
        }

        if (
          !searchDropdown.contains(event.target) &&
          !searchToggle.contains(event.target) &&
          !clickedInsideHeaderSearch
        ) {
          searchDropdown.classList.remove('is-open');
          this.hideOverlay();
        }
      });
    }

    shouldOpenMobileDropdown() {
      const dropdown = this.elements.searchDropdown;
      if (!dropdown) return false;
      const defaultAvailable = dropdown.dataset?.defaultAvailable === 'true';
      const hasQuery = Boolean(this.elements.mobileSearchInput?.value.trim());
      return defaultAvailable || hasQuery;
    }

    setupMenuHoverClose() {
      const { menuContainer, actionsContainer, logo } = this.elements;
      if (menuContainer) {
        menuContainer.addEventListener('pointerover', this.onMenuHover);
      }
      if (actionsContainer) {
        actionsContainer.addEventListener('pointerover', this.onMenuHover);
      }
      if (logo) {
        logo.addEventListener('pointerover', this.onMenuHover);
      }
      const overlay = this.elements.searchOverlay || document.querySelector('[data-header-search-overlay]');
      if (overlay) {
        this.elements.searchOverlay = overlay;
        overlay.addEventListener('pointerover', this.onMenuHover);
      }
    }

    showOverlay() {
      let overlay = this.elements.searchOverlay;
      if (!overlay) {
        overlay = document.querySelector('[data-header-search-overlay]');
        this.elements.searchOverlay = overlay;
      }
      if (!overlay) return;
      let headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
      if (Number.isNaN(headerHeight)) {
        headerHeight = this.elements.header?.offsetHeight || 0;
      }
      if (this.isMobile()) {
        const rect = this.elements.header?.getBoundingClientRect();
        if (rect) {
          headerHeight = rect.height;
        }
      }
      overlay.style.top = `${headerHeight}px`;
      overlay.classList.add('is-visible');
      overlay.setAttribute('aria-hidden', 'false');
    }

    hideOverlay(force = false) {
      let overlay = this.elements.searchOverlay;
      if (!overlay) {
        overlay = document.querySelector('[data-header-search-overlay]');
        this.elements.searchOverlay = overlay;
      }
      if (!overlay) return;
      if (this.isMobileSearchOpen() && !force) return;
      overlay.classList.remove('is-visible');
      overlay.setAttribute('aria-hidden', 'true');
    }

    onMenuHover(event) {
      const { searchDropdown, headerSearch } = this.elements;
      if (!searchDropdown?.classList.contains('is-open')) return;
      const overlay = this.elements.searchOverlay || document.querySelector('[data-header-search-overlay]');
      const hoveredOverlay = overlay?.contains(event.target);
      if (hoveredOverlay) {
        this.closeSearchFlyout();
        return;
      }
      const interactiveTarget = event.target.closest(
        '.header__menu-item, .list-menu__item, .header__action-item, .header__logo'
      );
      if (!interactiveTarget) return;
      if (headerSearch && headerSearch.contains(interactiveTarget)) return;
      this.closeSearchFlyout();
    }

    closeSearchFlyout() {
      const mainSearch = document.querySelector('main-search');
      if (mainSearch?.closeFlyout) {
        mainSearch.closeFlyout({ force: true });
      }
      document.querySelectorAll('predictive-search').forEach((predictive) => {
        if (typeof predictive.closeFlyout === 'function') {
          predictive.closeFlyout();
        }
      });
      this.elements.searchDropdown?.classList.remove('is-open');
      this.hideOverlay(true);
      const headerInputs = [
        ...Array.from(this.elements.headerSearch?.querySelectorAll('input[type="search"]') || []),
        ...Array.from(this.elements.searchDropdown?.querySelectorAll('input[type="search"]') || []),
      ];
      headerInputs.forEach((input) => {
        if (input === document.activeElement) {
          input.blur();
        }
      });
    }

    setupBackButton() {
      this.elements.backArrow.addEventListener('click', (event) => {
        event.preventDefault();
        this.closeMobileSearch({ focusToggle: true, resetInput: true });
      });
    }

    setupResizeHandler() {
      const onResize = () => {
        this.setMobileTopbarVisibility(!this.isMobileSearchOpen());
        this.resizeFrame = null;
        this.setHeaderHeightVar();
        if (!this.isMobile()) {
          this.closeMobileSearch({ focusToggle: false, resetInput: false });
          this.unlockScroll();
        } else {
          if (!this.isMobileSearchOpen()) {
            this.closeSearchFlyout();
            this.elements.searchDropdown?.classList.remove('is-open');
            this.hideOverlay(true);
          }
        }
      };

      window.addEventListener('resize', () => {
        if (this.resizeFrame) {
          cancelAnimationFrame(this.resizeFrame);
        }
        this.resizeFrame = requestAnimationFrame(onResize);
      });
    }

    setupKeyboardHandler() {
      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        if (this.isMobile() && this.isMobileSearchOpen()) {
          event.preventDefault();
          this.closeMobileSearch({ focusToggle: true, resetInput: false });
        } else if (!this.isMobile() && this.elements.searchDropdown?.classList.contains('is-open')) {
          event.preventDefault();
          this.closeSearchFlyout();
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new HeaderSearch();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-product-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const jdgmWidgetWrapperElem = document.querySelector('#judgeme_product_reviews');
    if (!jdgmWidgetWrapperElem) return;

    const jdgmWidgetElem = jdgmWidgetWrapperElem.querySelector('.jdgm-rev-widg');
    if (!jdgmWidgetElem) return;

    const averageRatingNumber = Number.parseFloat(jdgmWidgetElem.dataset.averageRating);
    const averageRating = Number.isFinite(averageRatingNumber)
      ? averageRatingNumber.toFixed(1)
      : jdgmWidgetElem.dataset.averageRating;

    jdgmWidgetWrapperElem.style.setProperty('--average-rating', `'${averageRating}'`);
    jdgmWidgetWrapperElem.style.setProperty('--reviews-number', `'${jdgmWidgetElem.dataset.numberOfReviews}'`);

    document.addEventListener('click', (event) => {
      const writeReviewLink = event.target.closest('#judgeme_product_reviews .jdgm-write-rev-link');
      if (!writeReviewLink) return;

      event.preventDefault();

      const details = jdgmWidgetWrapperElem.closest('details');
      if (details) details.open = true;

      const formWrapper = jdgmWidgetWrapperElem.querySelector('.jdgm-form-wrapper');
      if (!formWrapper) return;

      formWrapper.style.display = 'block';
      formWrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["step-slider"] && !Shopify.designMode) return;
  try {
    
  class StepSlider extends HTMLElement {
    constructor() {
      super();

      this.currentStep = 0;
      this.maxSteps = +this.dataset.maxSteps;
      this.prevButton = this.querySelector('.slider-button[name="previous"]');
      this.nextButton = this.querySelector('.slider-button[name="next"]');
      this.currentStepWrapper = this.querySelector('.step-slider__current-step-wrapper');
      this.slidesWrapper = this.querySelector('.step-slider__texts');
      this.slides = this.querySelectorAll('.step-slider__slide');

      this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
      this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
      this.slidesWrapper.addEventListener('keyup', this.onListKeyUp.bind(this));
    }

    update() {
      this.style.setProperty('--current-step', this.currentStep);

      if (this.currentStep === this.maxSteps) {
        this.disableButton(this.nextButton);
      } else {
        this.enableButton(this.nextButton);
      }

      if (this.currentStep === 0) {
        this.disableButton(this.prevButton);
      } else {
        this.enableButton(this.prevButton);
      }

      this.currentStepWrapper.innerText = this.currentStep + 1;
      this.setSlideAccessibility();
    }

    setSlideAccessibility() {
      this.slides.forEach((slide, index) => {
        if (index === this.currentStep) {
          slide.ariaHidden = 'false';
          return;
        }

        slide.ariaHidden = 'true';
      });
    }

    onButtonClick(event) {
      event.preventDefault();
      if (event.currentTarget.name === 'next') {
        this.currentStep = Math.min(this.currentStep + 1, this.maxSteps);
      } else {
        this.currentStep = Math.max(this.currentStep - 1, 0);
      }

      this.update();
    }

    onListKeyUp(event) {
      event.preventDefault();

      switch (event.key) {
        case 'ArrowRight':
          this.currentStep = Math.min(this.currentStep + 1, this.maxSteps);
          break;
        case 'ArrowLeft':
          this.currentStep = Math.max(this.currentStep - 1, 0);
          break;
        default:
          return;
      }

      this.update();
    }

    disableButton(buttonElem) {
      buttonElem.ariaDisabled = 'true';
      buttonElem.disabled = true;
    }

    enableButton(buttonElem) {
      buttonElem.removeAttribute('aria-disabled');
      buttonElem.removeAttribute('disabled');
    }
  }

  customElements.define('step-slider', StepSlider);

  } catch(e) { console.error(e); }
})();
})();
